import { EditorPlatform } from '@wix/ambassador-cc-helpcenter-v1-related-document/types';
import { ArticleType } from '@wix/answers-api';
import { ArticleSearchResultItem } from '@wix/cc-user-facing-common-components';

import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

export type SearchArticlesItem = {
  id: string;
  categoryId?: string;
  title: string;
  url: string;
  distance?: number;
  description?: string;
  type?: ArticleType;
  readingTimeInMinutes?: number;
  content?: string;
};

export const searchArticles = async (
  query: string,
  limit: number,
  offset: number,
  httpClient: HttpClientFactory,
  filters: {
    excludedCategories?: string[];
    categoriesIds?: string[];
    editorType?: EditorPlatform;
  },
): Promise<SearchArticlesItem[] | ArticleSearchResultItem[]> => {
  try {
    fedopsLogger.interactionStarted('fetching-search-articles');

    const response = await httpClient.getInstance().post(clientTopology.searchUrl, {
      query,
      limit,
      offset,
      filter: { ...filters },
    });

    fedopsLogger.interactionEnded('fetching-search-articles');
    return response.data.articles;
  } catch (error) {
    logger.error({
      message: `fail to fetch search articles by query: ${query}`,
      error,
    });
    console.error(error);
    throw error;
  }
};
